<template>
  <div>
    <Schedule
      v-for="schedule in schedules"
      :key="schedule.key"
      v-bind.sync="schedule"
      :max-settings="maxSettings"
      :current-settings="currentSettings"
    ></Schedule>
  </div>
</template>

<script>
import Schedule from '@/components/Schedule.vue';

export default {
  name: 'Schedules',
  components: {
    Schedule,
  },
  props: {
    schedules: {
      type: Array,
      required: true,
    },
    maxSettings: {
      type: Number,
      required: true,
    },
    currentSettings: {
      type: Number,
      required: true,
    },
  },
};
</script>
